<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Content: {{ content.content_id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 800px">
    <h5 class="mb-0" i18n>General Information</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Version</div>
        <div>{{ content.content_version }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Headline Text</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Headline text shown in the notification summary item. Text is displayed if present, otherwise the Headline Text ID is looked at to display the text."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.headline_text || '-' }}</div>
        <div class="field-label mt-3" i18n>Headline Text ID</div>
        <div>{{ content.headline_text_id }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Category Title Text</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Title text shown in the notification summary item. Text is displayed if present, otherwise the Category Title ID is looked at to display the text."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.category_title_text }}</div>
        <div class="field-label mt-3" i18n>Category Title ID</div>
        <div>{{ content.category_title_id }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Category Icon ID</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Icon displayed in the notification summary item."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.category_icon_id }}</div>
      </div>
      <div class="col">
        <div class="field-label d-flex">
          <div i18n>Min App Version</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Minimum app version that can recieve this content. Some features are only supported from certain versions onward."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.min_app_version }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Action Type</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Is optional, present only when special processing is needed by the app to handle it. The default value of 'content' means the application should just display the standard payload fields in order they are received."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.action_type }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Display Type</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Determines how the action content is displayed when the Notification Summary is selected."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.display_type }}</div>
        <div class="field-label mt-3" i18n>Language</div>
        <div>{{ content.language }}</div>
        <div class="field-label mt-3" i18n>Locale</div>
        <div>{{ content.locale || '-' }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Push Title String ID</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Title shown in the push notification. Value is taken from DRB."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.push_title_string_id || '-' }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Push String ID</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Body shown in the push notification. Value is taken from DRB."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ content.push_string_id || '-' }}</div>
      </div>
    </div>

    <h5 class="mb-0" i18n>Metadata</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Created By</div>
        <div>{{ content.created_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Created On</div>
        <div>{{ (content.created_dttm | customValueHandling: 'created_dttm') || '-' }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Last Updated By</div>
        <div>{{ content.last_updated_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Last Updated On</div>
        <div>{{ (content.last_updated_dttm | customValueHandling: 'last_updated_dttm') || '-' }}</div>
      </div>
    </div>

    <h5 *ngIf="content.action_button?.length > 0" class="mb-0" i18n>Action Button</h5>
    <hr *ngIf="content.action_button?.length > 0" />

    <div *ngIf="content.action_button?.length > 0" class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Button Text</div>
        <div>{{ content.action_button[0].text }}</div>
        <div class="field-label mt-3" i18n>Button Text ID</div>
        <div>{{ content.action_button[0].text_id }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Destination Type</div>
        <div>{{ content.action_button[0].destination_type }}</div>
        <div class="field-label mt-3" i18n>Destination URI</div>
        <div>{{ content.action_button[0].destination_uri }}</div>
        <div class="field-label mt-3" i18n>Destination URI ID</div>
        <div>{{ content.action_button[0].destination_uri_id }}</div>
      </div>
    </div>

    <h5 *ngIf="payloadRecords.length > 0" class="mb-0" i18n>Payload Records</h5>
    <hr *ngIf="payloadRecords.length > 0" />

    <div class="mb-5">
      <ng-container *ngFor="let payload_record of payloadRecords; let i = index">
        <div *ngIf="payload_record.payload_record_type !== 'multi_page_contextual_message'" class="mb-3">
          <nb-card accent="success">
            <nb-card-header>
              {{ payload_record.payload_record_type | replaceunderscore | titlecase }}
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col">
                  <div class="field-label" i18n>Action Display</div>
                  <div>{{ payload_record.action_display }}</div>
                  <div *ngIf="payload_record.content_text !== null" class="field-label mt-3" i18n>Content Text</div>
                  <div *ngIf="payload_record.content_text !== null">{{ payload_record.content_text }}</div>
                  <div *ngIf="payload_record.content_text_id !== null" class="field-label mt-3" i18n>
                    Content Text ID
                  </div>
                  <div *ngIf="payload_record.content_text_id !== null">{{ payload_record.content_text_id }}</div>
                  <div *ngIf="payload_record.context_text_display_order !== null" class="field-label mt-3" i18n>
                    Content Text Display Order
                  </div>
                  <div *ngIf="payload_record.context_text_display_order !== null">
                    {{ payload_record.context_text_display_order }}
                  </div>
                  <div *ngIf="payload_record.content_html !== null" class="field-label mt-3" i18n>Content HTML</div>
                  <div *ngIf="payload_record.content_html !== null">{{ payload_record.content_html }}</div>
                  <div *ngIf="payload_record.content_html_id !== null" class="field-label mt-3" i18n>
                    Content HTML ID
                  </div>
                  <div *ngIf="payload_record.content_html_id !== null">{{ payload_record.content_html_id }}</div>
                  <div *ngIf="payload_record.content_html_display_order !== null" class="field-label mt-3" i18n>
                    Content HTML Display Order
                  </div>
                  <div *ngIf="payload_record.content_html_display_order !== null">
                    {{ payload_record.content_html_display_order }}
                  </div>
                  <div *ngIf="payload_record.banner_id !== null" class="field-label mt-3" i18n>Banner ID</div>
                  <div *ngIf="payload_record.banner_id !== null">{{ payload_record.banner_id }}</div>
                  <div *ngIf="payload_record.banner_image_id !== null" class="field-label mt-3" i18n>
                    Banner Image ID
                  </div>
                  <div *ngIf="payload_record.banner_image_id !== null">{{ payload_record.banner_image_id }}</div>
                  <div *ngIf="payload_record.banner_text !== null" class="field-label mt-3" i18n>Banner Text</div>
                  <div *ngIf="payload_record.banner_text !== null">{{ payload_record.banner_text }}</div>
                  <div *ngIf="payload_record.disclaimers_text !== null" class="field-label mt-3 d-flex">
                    <div i18n>Disclaimers Text</div>
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="Disclaimer text shown at the end of the content body in a smaller font."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                  <div *ngIf="payload_record.disclaimers_text !== null">{{ payload_record.disclaimers_text }}</div>
                  <div *ngIf="payload_record.source_code !== null" class="field-label mt-3 d-flex">
                    <div i18n>Source Code</div>
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="Promotion code with the native Product Personalization Feed experience that will be applied at checkout."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                  <div *ngIf="payload_record.source_code !== null">{{ payload_record.source_code }}</div>
                </div>
                <div class="col">
                  <div *ngIf="payload_record.image_id !== null" class="field-label" i18n>Image ID</div>
                  <div *ngIf="payload_record.image_id !== null">{{ payload_record.image_id }}</div>
                  <div *ngIf="payload_record.image_url !== null" class="field-label mt-3" i18n>Image URL</div>
                  <div *ngIf="payload_record.image_url !== null">{{ payload_record.image_url }}</div>
                  <div *ngIf="payload_record.image_display_order !== null" class="field-label mt-3" i18n>
                    Image Display Order
                  </div>
                  <div *ngIf="payload_record.image_display_order !== null">
                    {{ payload_record.image_display_order }}
                  </div>
                  <div *ngIf="payload_record.video_id !== null" class="field-label mt-3" i18n>Video ID</div>
                  <div *ngIf="payload_record.video_id !== null">{{ payload_record.video_id }}</div>
                  <div *ngIf="payload_record.video_url_display_order !== null" class="field-label mt-3" i18n>
                    Video URL Display Order
                  </div>
                  <div *ngIf="payload_record.video_url_display_order !== null">
                    {{ payload_record.video_url_display_order }}
                  </div>
                  <div *ngIf="payload_record.script_id !== null" class="field-label mt-3 d-flex">
                    <div i18n>Script ID</div>
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="This references a scripted navigation flow, which is stored within the DRB. Any value for this field is only valid when action type is scripted navigation. Moreover, all other content fields will be ignored, and the display order of this field will be 0."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                  <div *ngIf="payload_record.script_id !== null">{{ payload_record.script_id }}</div>
                  <div *ngIf="payload_record.script_id_display_order !== null" class="field-label mt-3" i18n>
                    Script ID Display Order
                  </div>
                  <div *ngIf="payload_record.script_id_display_order !== null">
                    {{ payload_record.script_id_display_order }}
                  </div>
                  <div *ngIf="payload_record.webview_url !== null" class="field-label mt-3 d-flex">
                    <div i18n>WebView URL</div>
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="The URL that will be used to populate a web view displayed when the message is opened. The content text field can be used to supply a heading to the web view container."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                  <div *ngIf="payload_record.webview_url !== null">{{ payload_record.webview_url }}</div>
                  <div *ngIf="payload_record.webview_url_id !== null" class="field-label mt-3" i18n>WebView URL ID</div>
                  <div *ngIf="payload_record.webview_url_id !== null">{{ payload_record.webview_url_id }}</div>
                  <div *ngIf="payload_record.webview_url_display_order !== null" class="field-label mt-3" i18n>
                    WebView URL Display Order
                  </div>
                  <div *ngIf="payload_record.webview_url_display_order !== null">
                    {{ payload_record.webview_url_display_order }}
                  </div>
                  <div *ngIf="payload_record.product_url !== null" class="field-label mt-3 d-flex">
                    <div i18n>Product URL</div>
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="Store URL of the product. Used in banners."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                  <div *ngIf="payload_record.product_url !== null">{{ payload_record.product_url }}</div>
                </div>
              </div>
            </nb-card-body>
          </nb-card>
        </div>
      </ng-container>

      <!-- Multi Page Contextual Message — one tab per page -->
      <div *ngIf="hasMultiPageRecords" class="mb-3">
        <nb-card accent="success">
          <nb-card-header i18n>Multi Page Contextual Message</nb-card-header>
          <nb-card-body>
            <div *ngIf="content.active_parent_uri_id" class="mb-3">
              <div class="field-label" i18n>Active Parent URI</div>
              <div>{{ content.active_parent_uri_id }}</div>
            </div>
            <nb-tabset>
              <nb-tab *ngFor="let page of multiPageRecords; let pageIdx = index" [tabTitle]="'Page ' + (pageIdx + 1)">
                <div class="row">
                  <div class="col">
                    <div class="field-label" i18n>Action Display</div>
                    <div>{{ page.action_display }}</div>
                    <ng-container *ngIf="page.content_text !== null">
                      <div class="field-label mt-3" i18n>Content Text</div>
                      <div>{{ page.content_text }}</div>
                    </ng-container>
                    <ng-container *ngIf="page.content_text_id !== null">
                      <div class="field-label mt-3" i18n>Content Text ID</div>
                      <div>{{ page.content_text_id }}</div>
                    </ng-container>
                    <ng-container *ngIf="page.context_text_display_order !== null">
                      <div class="field-label mt-3" i18n>Content Text Display Order</div>
                      <div>{{ page.context_text_display_order }}</div>
                    </ng-container>
                    <ng-container *ngIf="page.content_html !== null">
                      <div class="field-label mt-3" i18n>Content HTML</div>
                      <div>{{ page.content_html }}</div>
                    </ng-container>
                    <ng-container *ngIf="page.content_html_id !== null">
                      <div class="field-label mt-3" i18n>Content HTML ID</div>
                      <div>{{ page.content_html_id }}</div>
                    </ng-container>
                    <ng-container *ngIf="page.content_html_display_order !== null">
                      <div class="field-label mt-3" i18n>Content HTML Display Order</div>
                      <div>{{ page.content_html_display_order }}</div>
                    </ng-container>
                  </div>
                  <div class="col">
                    <ng-container *ngIf="page.image_id !== null">
                      <div class="field-label" i18n>Image ID</div>
                      <div>{{ page.image_id }}</div>
                    </ng-container>
                    <ng-container *ngIf="page.image_url !== null">
                      <div class="field-label mt-3" i18n>Image URL</div>
                      <div>{{ page.image_url }}</div>
                    </ng-container>
                    <ng-container *ngIf="page.image_display_order !== null">
                      <div class="field-label mt-3" i18n>Image Display Order</div>
                      <div>{{ page.image_display_order }}</div>
                    </ng-container>
                  </div>
                </div>
              </nb-tab>
            </nb-tabset>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf="canPreviewContent">
    <div class="d-flex justify-content-end">
      <button
        nbButton
        status="info"
        [disabled]="!marketing || !marketing_translations"
        (click)="previewContent()"
        [nbSpinner]="!marketing || !marketing_translations"
        nbSpinnerStatus="info"
        i18n
      >
        Preview Content
      </button>
    </div>
  </nb-card-footer>
</nb-card>
